import React from 'react';
import { 
  Box, 
  Typography, 
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
  TextField,
  InputAdornment,
  Container,
  Hidden
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom';


const ProductCatalog = () => {
  // Mock data for products
  const products = [
    {
      id: 'Landsat-8-9',
      name: 'Landsat 8/9',
      description: "30 m resolution MSI satellite data providing long-term, consistent EO for land cover and climate studies. Explore more...",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '2 day revisit', color: 'default' },
        // {  label:'', color: 'default' },
        { label: '30m Resolution', color: 'default' }
      ],
      levels: ['Catalog']
    },
    {
      id: 'Sentinel-2',
      name: 'Sentinel - 2',
      description: "A High Swath multispectral satellite data ideal for vegetation, land use, and environmental monitoring. Explore more....",
      image: 'data:image/jpeg;base64,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',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '2 day revisit', color: 'default' },
        // {  label:'', color: 'default' },
        { label: '10m Resolution', color: 'default' }
      ],
      levels: ['Catalog']
    },
    {
      id: 'OPT-120',
      name: 'OPT-120',
      description: 'A 1.2 m multispectral, wide swath imager designed for large area coverage and high-resolution imaging. Explore more....',
      image: 'https://kaleideo.co/wp-content/uploads/2025/01/opt.png',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1 day revisit', color: 'default' },
        { label: '1.2m Resolution', color: 'default' }
      ],
      levels: ['Catalog', 'Tasking']
    },
    {
      id: 'opt-70',
      name: 'OPT - 70',
      description: 'A 0.7 m high-resolution, submeter imager for detailed Earth observation. Explore more....',
      image: 'https://kaleideo.co/wp-content/uploads/2025/01/Clip-path-group.webp',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1 day revisit', color: 'default' },
        { label: '70cm Resolution', color: 'default' }
      ],
      levels: ['Catalog', 'Tasking']
    },
    // {
    //   id: 'KaleidEO Aerial_Test_Imagery',
    //   name: 'KaleidEO Aerial Test Imagery (Coming soon...)',
    //   description: "Ultra-high-resolution aerial imagery captured during KaleidEO's EO payload testing phase. Explore more....",
    //   image: 'https://i.postimg.cc/d0pXBZ02/Screenshot-2025-02-10-204843.png',
    //   tags: [
    //     { label: 'Optical', color: 'primary' },
    //     // {  label:'', color: 'default' },
    //     { label: '16cm Resolution', color: 'default' }
    //   ],
    //   levels: ['Catalog']
    // }


  ];
  const history = useHistory();
  const handleProductClick = (productId) => {
    console.log(productId)
    if(productId=='OPT-120'){
      history.push('/products/OPT-120')
    }
    else if(productId=='opt-70'){
      history.push('/products/OPT-70')
    }
    else if(productId=='Sentinel-2'){
      history.push('/products/Sentinel-2')
    }
    else if(productId=='Landsat-8-9'){
      history.push('/products/Landsat-8-9')
    }
    else if(productId=='Sentinel-1'){
      history.push('/products/Sentinel-1')
    }
    else if(productId=='Cartosat-2A'){
      history.push('/products/Cartosat-2A')
    }
    else if(productId=='Cartosat-2B'){
      history.push('/products/Cartosat-2B')
    }
    else if(productId=='Cartosat-2C'){
      history.push('/products/Cartosat-2C')
    }
    else if(productId=='Cartosat-2D'){
      history.push('/products/Cartosat-2D')
    }
    else if(productId=='Cartosat-2E'){
      history.push('/products/Cartosat-2E')
    }
    else if(productId=='Cartosat-2F'){
      history.push('/products/Cartosat-2F')
    }
    else if(productId=='Cartosat-3'){
      history.push('/products/Cartosat-3')
    }
    else if(productId=='ndvi_s2'){
      history.push('/products/ndvi_s2')
    }
    else if(productId=='ndwi_s2'){
      history.push('/products/ndwi_s2')
    }
    else{

    }
    
  };

  const handleOrderClick = () => {
    // Navigate to order page
    history.push('/explore');
  };

  // Add Sentinel-1 and Cartosat products to the products array
  const allProducts = [
    ...products,
    {
      id: 'Sentinel-1',
      name: 'Sentinel-1',
      description: "C-band SAR satellite data providing all-weather, day-and-night imagery for land and ocean monitoring. Explore more...",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'SAR', color: 'primary' },
        { label: '6 day revisit', color: 'default' },
        { label: '10m Resolution', color: 'default' }
      ],
      levels: ['Catalog']
    },
    {
      id: 'Cartosat-2A',
      name: 'Cartosat-2A',
      description: "High-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    },
    {
      id: 'Cartosat-2B',
      name: 'Cartosat-2B',
      description: "High-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    },
    {
      id: 'Cartosat-2C',
      name: 'Cartosat-2C',
      description: "High-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    },
    {
      id: 'Cartosat-2D',
      name: 'Cartosat-2D',
      description: "High-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    },
    {
      id: 'Cartosat-2E',
      name: 'Cartosat-2E',
      description: "High-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    },
    {
      id: 'Cartosat-2F',
      name: 'Cartosat-2F',
      description: "High-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '1m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    },
    {
      id: 'Cartosat-3',
      name: 'Cartosat-3',
      description: "Advanced high-resolution optical satellite for detailed Earth observation and mapping applications.",
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpvWXFnx-CBSoyit6AOhdoakXcY4tsqDgiMw&s',
      tags: [
        { label: 'Optical', color: 'primary' },
        { label: '0.25m Resolution', color: 'default' }
      ],
      levels: ['Tasking']
    }
  ];

  // Filter products into sections
  const catalogProducts = allProducts.filter(p => 
    ['Sentinel-2', 'Landsat-8-9', 'Sentinel-1'].includes(p.id)
  );
  
  const taskingProducts = allProducts.filter(p => 
    ['Cartosat-2A', 'Cartosat-2B', 'Cartosat-2C', 'Cartosat-2D', 'Cartosat-2E', 'Cartosat-2F', 'Cartosat-3'].includes(p.id)
  );
  
  const comingSoonProducts = allProducts.filter(p => 
    ['OPT-120', 'opt-70'].includes(p.id)
  );

  // Commented out - Analytics Products Section
  // const analyticsProducts = [
  //   {
  //     id: 'ndvi_s2',
  //     name: 'NDVI – Sentinel-2',
  //     description: 'Normalized Difference Vegetation Index used to assess crop and vegetation health.',
  //     image: 'https://volatusdrones.com/cdn/shop/articles/5-ndvi-mapping-tips-965717_600x.png?v=1681404936',
  //     tags: [
  //       { label: 'Vegetation', color: 'default' },
  //       { label: '10m Resolution', color: 'default' },
  //       { label: '5 day Revisit', color: 'default' }
  //     ],
  //     levels: ['Catalog']
  //   },
  //   {
  //     id: 'ndwi_s2',
  //     name: 'NDWI – Sentinel-2',
  //     description: 'Normalized Difference Water Index used to detect water presence and flooded regions.',
  //     image: 'https://custom-scripts.sentinel-hub.com/custom-scripts/sentinel-2/ndwi/fig/fig1.jpg',
  //     tags: [
  //       { label: 'Water', color: 'primary' },
  //       { label: '10m Resolution', color: 'default' },
  //       { label: '5 day Revisit', color: 'default' }
  //     ],
  //     levels: ['Catalog']
  //   },
  //   {
  //     id: 'ndvi_opt70',
  //     name: 'NDVI – OPT70',
  //     description: 'Normalized Difference Vegetation Index used to assess crop and vegetation health.',
  //     image: 'https://volatusdrones.com/cdn/shop/articles/5-ndvi-mapping-tips-965717_600x.png?v=1681404936',
  //     tags: [
  //       { label: 'Vegetation', color: 'default' },
  //       { label: '0.7m Resolution', color: 'default' },
  //       { label: '1 day Revisit', color: 'default' }
  //     ],
  //     levels: ['Catalog', 'Tasking']
  //   },
  //   {
  //     id: 'ndwi_opt70',
  //     name: 'NDWI – OPT70',
  //     description: 'Normalized Difference Water Index used to detect water presence and flooded regions.',
  //     image: 'https://custom-scripts.sentinel-hub.com/custom-scripts/sentinel-2/ndwi/fig/fig1.jpg',
  //     tags: [
  //       { label: 'Water', color: 'default' },
  //       { label: '0.7m Resolution', color: 'default' },
  //       { label: '1 day Revisit', color: 'default' }
  //     ],
  //     levels: ['Catalog', 'Tasking']
  //   }
  // ];
  


  return (
    <Box sx={{ 
      width: '100%',
      maxWidth: '100%',
      overflowX: 'hidden',
      boxSizing: 'border-box',
      m: 0,
      p: 0
    }}>
      {/* Search and Order Button Bar */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mb: 2.5,
        py:1.5,
        px: { xs: 1, sm: 2 },
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        gap: { xs: 1, sm: 0 },
        boxSizing: 'border-box',
        width: '100%'
      }}>
        <TextField
          placeholder="Search"
          variant="outlined"
          size="small"
          sx={{ 
            width: { xs: '100%', sm: 300 },
            '& .MuiOutlinedInput-root': {
              borderRadius: '4px',
              height: '38px'
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#007bff' }} />
              </InputAdornment>
            )
          }}
        />
        
        <Button
          variant="contained"
          onClick={handleOrderClick}
          sx={{
            bgcolor: '#007bff',
            color: 'white',
            textTransform: 'none',
            borderRadius: '4px',
            padding: '6px 16px',
            fontSize: '0.875rem',
            fontWeight: 500,
            width: { xs: '100%', sm: 'auto' },
            '&:hover': {
              bgcolor: '#0069d9'
            }
            
          }}
        >
          ORDER IMAGERY
        </Button>
      </Box>

      {/* Product Grid */}
      {/* Catalog Products Section */}
<Box sx={{ px: { xs: 1, sm: 2 }, mb: 4 }}>
  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Catalog Products
  </Typography>
  <Grid container spacing={2}>
          {catalogProducts.map((product) => (
      <Grid item xs={12} sm={6} md={4} lg={3} key={product.id}>
        <Card 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            cursor: 'pointer',
            borderRadius: 1,
            overflow: 'hidden',
            bgcolor: '#f8f8f8',
            width: '100%',
            border: '1px solid #e0e0e0',
            boxShadow: 'none',
            height: 'auto',
            '&:hover': {
              boxShadow: 1
            }
          }}
          onClick={() => handleProductClick(product.id)}
        >
          <Box sx={{ position: 'relative' }}>
            <CardMedia
              component="img"
              sx={{ 
                bgcolor: '#000',
                height: 150,
                objectFit: 'cover'
              }}
              image={product.image}
              alt={product.name}
            />
            <Box 
              sx={{ 
                position: 'absolute', 
                bottom: 8, 
                left: 8, 
                display: 'flex', 
                flexWrap: 'wrap',
                gap: 1 
              }}
            >
              {product.tags.map((tag, index) => (
                <Chip
                  key={index}
                  label={tag.label}
                  size="small"
                  sx={{ 
                    height: '24px',
                    borderRadius: '4px',
                    bgcolor: tag.label === 'Optical' ? '#007bff' : 
                            tag.label === 'SAR' ? '#9c27b0' : 'rgba(255, 255, 255, 0.85)',
                    color: tag.label === 'Optical' || tag.label === 'SAR' ? 'white' : 'black',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                    '& .MuiChip-label': {
                      padding: '0 8px'
                    }
                  }}
                />
              ))}
            </Box>
          </Box>
          <CardContent sx={{ flexGrow: 1, bgcolor: '#f9f9f9', p: 2 }}>
            <Typography variant="h6" component="div" sx={{ mb: 1, fontSize: '1rem', fontWeight: 500 }}>
              {product.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, fontSize: '0.875rem' }}>
              {product.description}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {product.levels.map((level, index) => (
                <Chip
                  key={index}
                  label={level}
                  size="small"
                  variant="outlined"
                  sx={{ 
                    height: '24px',
                    borderRadius: '4px',
                    borderColor: '#dddddd', 
                    color: '#007bff',
                    bgcolor: 'white',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                    '& .MuiChip-label': {
                      padding: '0 8px'
                    }
                  }}
                />
              ))}
            </Box>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
</Box>

      {/* Tasking Products Section */}
      <Box sx={{ px: { xs: 1, sm: 2 }, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Tasking Products
        </Typography>
        <Grid container spacing={2}>
          {taskingProducts.map((product) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={product.id}>
              <Card 
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  cursor: 'pointer',
                  borderRadius: 1,
                  overflow: 'hidden',
                  bgcolor: '#f8f8f8',
                  width: '100%',
                  border: '1px solid #e0e0e0',
                  boxShadow: 'none',
                  height: 'auto',
                  '&:hover': {
                    boxShadow: 1
                  }
                }}
                onClick={() => handleProductClick(product.id)}
              >
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    sx={{ 
                      bgcolor: '#000',
                      height: 150,
                      objectFit: 'cover'
                    }}
                    image={product.image}
                    alt={product.name}
                  />
                  <Box 
                    sx={{ 
                      position: 'absolute', 
                      bottom: 8, 
                      left: 8, 
                      display: 'flex', 
                      flexWrap: 'wrap',
                      gap: 1 
                    }}
                  >
                    {product.tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag.label}
                        size="small"
                        sx={{ 
                          height: '24px',
                          borderRadius: '4px',
                          bgcolor: tag.label === 'Optical' ? '#007bff' : 
                                  tag.label === 'SAR' ? '#9c27b0' : 'rgba(255, 255, 255, 0.85)',
                          color: tag.label === 'Optical' || tag.label === 'SAR' ? 'white' : 'black',
                          fontWeight: 500,
                          fontSize: '0.75rem',
                          '& .MuiChip-label': {
                            padding: '0 8px'
                          }
                        }}
                      />
                    ))}
                  </Box>
                </Box>
                <CardContent sx={{ flexGrow: 1, bgcolor: '#f9f9f9', p: 2 }}>
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontSize: '1rem', fontWeight: 500 }}>
                    {product.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, fontSize: '0.875rem' }}>
                    {product.description}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {product.levels.map((level, index) => (
                      <Chip
                        key={index}
                        label={level}
                        size="small"
                        variant="outlined"
                        sx={{ 
                          height: '24px',
                          borderRadius: '4px',
                          borderColor: '#dddddd', 
                          color: '#007bff',
                          bgcolor: 'white',
                          fontWeight: 500,
                          fontSize: '0.75rem',
                          '& .MuiChip-label': {
                            padding: '0 8px'
                          }
                        }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Coming Soon Products Section */}
<Box sx={{ px: { xs: 1, sm: 2 }, mb: 4 }}>
  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Coming Soon Products
  </Typography>
  <Grid container spacing={2}>
          {comingSoonProducts.map((product) => (
      <Grid item xs={12} sm={6} md={4} lg={3} key={product.id}>
        <Card 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            cursor: 'pointer',
            borderRadius: 1,
            overflow: 'hidden',
            bgcolor: '#f8f8f8',
            width: '100%',
            border: '1px solid #e0e0e0',
            boxShadow: 'none',
            height: 'auto',
            '&:hover': {
              boxShadow: 1
            }
          }}
          onClick={() => handleProductClick(product.id)}
        >
          <Box sx={{ position: 'relative' }}>
            <CardMedia
              component="img"
              sx={{ 
                bgcolor: '#000',
                height: 150,
                objectFit: 'cover'
              }}
              image={product.image}
              alt={product.name}
            />
            <Box 
              sx={{ 
                position: 'absolute', 
                bottom: 8, 
                left: 8, 
                display: 'flex', 
                flexWrap: 'wrap',
                gap: 1 
              }}
            >
              {product.tags.map((tag, index) => (
                <Chip
                  key={index}
                  label={tag.label}
                  size="small"
                  sx={{ 
                    height: '24px',
                    borderRadius: '4px',
                          bgcolor: tag.label === 'Optical' ? '#007bff' : 
                                  tag.label === 'SAR' ? '#9c27b0' : 'rgba(255, 255, 255, 0.85)',
                          color: tag.label === 'Optical' || tag.label === 'SAR' ? 'white' : 'black',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                    '& .MuiChip-label': {
                      padding: '0 8px'
                    }
                  }}
                />
              ))}
            </Box>
          </Box>
          <CardContent sx={{ flexGrow: 1, bgcolor: '#f9f9f9', p: 2 }}>
            <Typography variant="h6" component="div" sx={{ mb: 1, fontSize: '1rem', fontWeight: 500 }}>
              {product.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, fontSize: '0.875rem' }}>
              {product.description}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {product.levels.map((level, index) => (
                <Chip
                  key={index}
                  label={level}
                  size="small"
                  variant="outlined"
                  sx={{ 
                    height: '24px',
                    borderRadius: '4px',
                    borderColor: '#dddddd', 
                          color: '#007bff',
                    bgcolor: 'white',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                    '& .MuiChip-label': {
                      padding: '0 8px'
                    }
                  }}
                />
              ))}
            </Box>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
</Box>

    </Box>
  );
};

export default ProductCatalog;